import React from 'react';
import { Lightbulb, Layers, UserCheck, Rocket } from 'lucide-react';
import { whyChooseUs } from '../mockData';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const iconMap = {
  lightbulb: Lightbulb,
  layers: Layers,
  'user-check': UserCheck,
  rocket: Rocket
};

const WhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#1A3E6E] font-semibold text-sm uppercase tracking-wide">
            Why Choose Us
          </span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-bold text-gray-900">
            Your Trusted Technology Partner
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            We combine cutting-edge AI expertise with full-stack development capabilities 
            to deliver transformative solutions.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyChooseUs.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <Card
                key={item.id}
                className="text-center hover:shadow-lg transition-all duration-300 border-2 hover:border-[#1A3E6E] group"
              >
                <CardHeader>
                  <div className="mx-auto mb-4 w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center group-hover:bg-[#1A3E6E] transition-colors duration-300">
                    <IconComponent className="text-[#1A3E6E] group-hover:text-white transition-colors duration-300" size={32} />
                  </div>
                  <CardTitle className="text-xl group-hover:text-[#1A3E6E] transition-colors">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600">
                    {item.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
